import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'box',
    templateUrl: './box.html',
    styleUrls: ['./box.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoxComponent {
    /**
     * if selected
     */
    @Input()
    selected = false;

    @Input()
    @HostBinding('class.disabled')
    disabled = false;
}
